import type { IntlShape } from 'react-intl';

import { agentTodoMessages } from './agentTodo.messages';
import type { AgentTodoOperation } from './types';

/** In-flight copy for todo operations. */
export const runningTodoLabel = (
  intl: IntlShape,
  operation: AgentTodoOperation,
  count: number
): string => {
  switch (operation) {
    case 'create':
      return intl.formatMessage(agentTodoMessages.creatingTodo, { count });
    case 'set':
      return intl.formatMessage(agentTodoMessages.settingTodo, { count });
    case 'update':
      return intl.formatMessage(agentTodoMessages.updatingTodo, { count });
    case 'complete':
      return intl.formatMessage(agentTodoMessages.completingTodo, { count });
    case 'delete':
      return intl.formatMessage(agentTodoMessages.deletingTodo, { count });
    case 'get':
      return intl.formatMessage(agentTodoMessages.gettingTodo, { count });
  }
};

/** Completed header for todo operations. */
export const completedTodoLabel = (
  intl: IntlShape,
  operation: AgentTodoOperation,
  count: number
): string => {
  switch (operation) {
    case 'create':
      return intl.formatMessage(agentTodoMessages.createTodo, { count });
    case 'set':
      return intl.formatMessage(agentTodoMessages.setTodo, { count });
    case 'update':
      return intl.formatMessage(agentTodoMessages.updateTodo, { count });
    case 'complete':
      return intl.formatMessage(agentTodoMessages.completeTodo, { count });
    case 'delete':
      return intl.formatMessage(agentTodoMessages.deleteTodo, { count });
    case 'get':
      return intl.formatMessage(agentTodoMessages.getTodo, { count });
  }
};

export const failedTodoLabel = (
  intl: IntlShape,
  operation: AgentTodoOperation,
  count: number
): string => {
  const completed = completedTodoLabel(intl, operation, count);
  return intl.formatMessage(agentTodoMessages.operationFailed, { title: completed });
};
